import React from 'react'
import t from '../../translations/i18n'

export default function Footer() {
  return (
    <footer id="footer">
      <div className="footer-top">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="footer-contact">
                <h3>{t('general.bussines_name')}</h3>

                <p>{t('sections.init_subtitle')}</p>

                <div className="footer-contact-info">
                  <div>
                    <strong>{t('sections.contact_dirt')}</strong>
                    <br />
                    {t('sections.contact_dirs')}
                  </div>

                  <br />

                  <div>
                    <strong>{t('sections.contact_emailt')}</strong>
                    <br />
                    {t('sections.contact_emails')}
                  </div>

                  <br />

                  <div>
                    <strong>{t('sections.contact_phonet')}</strong>
                    <br />
                    {t('sections.contact_phgonesu')}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-6 text-lg-end mt-4 mt-lg-0">
              <h4>Nuestras Redes Sociales</h4>

              <p>
                Síguenos para conocer nuestros últimos proyectos, tecnologías y
                soluciones empresariales.
              </p>

              <div className="social-links mt-3">
                <a href="!#" className="facebook">
                  <i className="bx bxl-facebook"></i>
                </a>

                <a href="!#" className="instagram">
                  <i className="bx bxl-instagram"></i>
                </a>

                <a href="!#" className="linkedin">
                  <i className="bx bxl-linkedin"></i>
                </a>

                <a href="!#" className="github">
                  <i className="bx bxl-github"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container py-4">
        <div className="copyright">
          © {new Date().getFullYear()}{' '}
          <strong>{t('general.bussines_name')}</strong>. Todos los derechos
          reservados.
        </div>
      </div>
    </footer>
  )
}
